export default "__VITE_ASSET__BCh4HyzN__"